const state = () => ({
  /** @type AppMessage */
  defaults: {
    code: null,
    isActive: false,
    text: null,
  },
  views: {
    /** @type AppMessageView */
  },
})

export default state
